/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tip_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split a 90 total between 3 people = 30 each.`)
};

const es_pct_tip_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repartir un total de 90 entre 3 personas = 30 cada una.`)
};

const de_pct_tip_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Gesamtbetrag von 90 aufgeteilt auf 3 Personen = 30 pro Person.`)
};

const nl_pct_tip_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdeel een totaal van 90 tussen 3 personen = 30 per persoon.`)
};

const fr_pct_tip_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager un total de 90 entre 3 personnes = 30 chacune.`)
};

const it_pct_tip_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi un totale di 90 tra 3 persone = 30 a testa.`)
};

const pt_br2_pct_tip_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida um total de 90 entre 3 pessoas = 30 cada.`)
};

const pt_pct_tip_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividir um total de 90 entre 3 pessoas = 30 cada.`)
};

const ja_pct_tip_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計90を3人で割る = 一人30。`)
};

const zh_pct_tip_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`90 的总额由 3 人分摊 = 每人 30。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tip_ex4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tip_ex4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tip_ex4", locale)
	if (locale === "en") return en_pct_tip_ex4(inputs)
	if (locale === "es") return es_pct_tip_ex4(inputs)
	if (locale === "de") return de_pct_tip_ex4(inputs)
	if (locale === "nl") return nl_pct_tip_ex4(inputs)
	if (locale === "fr") return fr_pct_tip_ex4(inputs)
	if (locale === "it") return it_pct_tip_ex4(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tip_ex4(inputs)
	if (locale === "pt") return pt_pct_tip_ex4(inputs)
	if (locale === "ja") return ja_pct_tip_ex4(inputs)
	return zh_pct_tip_ex4(inputs)
};